
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.977 1.055l2.68 4.047v.46L2.647 9.712h3.54c.453 0 .78-.102.984-.305.203-.203.37-.664.5-1.383h.781L8.281 11H.875v-.383l3.5-4.812L1.094.719V.336h7.218v2.726h-.734c-.213-.838-.435-1.382-.664-1.632-.224-.25-.55-.375-.976-.375H2.977z","fill":"currentColor"}})])
          )
        }
      }
    